function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m293 78.53c-43.356-75.095-139.38-100.83-214.47-57.462-75.095 43.35-100.83 139.37-57.463 214.47 43.35 75.095 139.38 100.83 214.46 57.47 75.096-43.365 100.84-139.38 57.471-214.47zm-73.168 187.27c-60.067 34.692-136.89 14.106-171.58-45.973-34.69-60.067-14.097-136.89 45.972-171.57 60.071-34.69 136.89-14.106 171.58 45.971 34.685 60.076 14.098 136.89-45.974 171.57zm-6.279-115.15l-82.214-47.949c-7.492-4.374-13.535-0.877-13.493 7.789l0.421 95.174c0.038 8.664 6.155 12.191 13.669 7.851l81.585-47.103c7.506-4.332 7.522-11.388 0.032-15.762z"
});

var SvgPlayBtn = function SvgPlayBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "314.07px",
    height: "314.07px",
    enableBackground: "new 0 0 314.068 314.068",
    viewBox: "0 0 314.068 314.068",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play-btn.a3063440.svg";
export { ForwardRef as ReactComponent };